import React, { PureComponent, Fragment } from 'react';
import renderHTML from 'react-render-html';
import { Helmet } from "react-helmet";
import Header from 'components/header/header.component';

// Styles
import {
  StyledUseWrapper,
  StyledTextWrapper,
} from "./programDetails.style";

import {
  StyledElementHeaderTitle,
  StyledElementHeaderDescription,
  StyledElementWrapper,
  StyledElementWrapperCenter
} from 'styledElements';

// Texts
import text from 'i18l';


class ProgramDetailsComponent extends PureComponent {
  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    const {match: {params: { id }}} = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{text.ABOUT.PROGRAMS[id].metaTitle}</title>
          <meta name="description" content={text.ABOUT.PROGRAMS[id].metaDescription} />
        </Helmet>
        <Header/>
        <StyledElementWrapper>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                {text.ABOUT.PROGRAMS[id].name}
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                {text.ABOUT.PROGRAMS_DESCRIPTION}
              </StyledElementHeaderDescription>
            </header>
            <StyledTextWrapper>
              {renderHTML(text.ABOUT.PROGRAMS[id].fullDescription)}
            </StyledTextWrapper>

          </StyledElementWrapperCenter>
        </StyledElementWrapper>
        <StyledUseWrapper>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                Sposób
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                KORZYSTANIA
              </StyledElementHeaderDescription>
            </header>
            <StyledTextWrapper>
              {renderHTML(text.ABOUT.PROGRAMS[id].useDescription)}
            </StyledTextWrapper>

          </StyledElementWrapperCenter>
        </StyledUseWrapper>
        {text.ABOUT.PROGRAMS[id].additionalText && (<StyledUseWrapper more>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                Opis programu
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                {text.ABOUT.PROGRAMS[id].name}
              </StyledElementHeaderDescription>
            </header>
            <StyledTextWrapper>
              {renderHTML(text.ABOUT.PROGRAMS[id].additionalText)}
            </StyledTextWrapper>

          </StyledElementWrapperCenter>
        </StyledUseWrapper>)}
      </Fragment>
    );
  }
}

export default ProgramDetailsComponent;



// WEBPACK FOOTER //
// ./src/routes/programDetails/programDetails.component.js